export const KVKK_TEXT = `FIVE STAR KİŞİSEL VERİLERİN İŞLENMESİNE İLİŞKİN AYDINLATMA METNİ
Son güncelleme: 16 Eylül 2026
Five Star olarak kişisel verilerinin güvenliğine ve özel hayatının gizliliğine önem veriyoruz.
Bu Aydınlatma Metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında, Five Star mobil uygulaması ve meetfivestar.app internet sitesi üzerinden hangi kişisel verilerinin toplandığını, bu verilerin hangi amaçlarla işlendiğini, kimlere aktarılabileceğini, hangi yöntemlerle toplandığını ve KVKK kapsamındaki haklarını açıklamak amacıyla hazırlanmıştır.
1. VERİ SORUMLUSU
KVKK kapsamında kişisel verilerinin veri sorumlusu:
[YASAL ŞİRKET / TÜZEL KİŞİ UNVANI]
Marka: Five Star
Web: meetfivestar.app
E-posta: privacy@meetfivestar.app
Adres: [YASAL ADRES]
olarak belirlenecektir.
2. İŞLENEN KİŞİSEL VERİLER
Five Star’ın kullanılması sırasında aşağıdaki kişisel veri kategorileri işlenebilir:
Kimlik ve profil bilgileri:
Ad, soyad, doğum tarihi, yaş, cinsiyet ve profil bilgileri.
İletişim bilgileri:
E-posta adresi ve ileride eklenmesi halinde telefon numarası.
Başvuru bilgileri:
Üyelik başvurusunda verilen yanıtlar, tercihler ve başvuru değerlendirmesinde kullanılan bilgiler.
Sosyal medya bilgileri:
Instagram kullanıcı adı.
Görsel veriler:
Profil fotoğrafları ve Platforma yüklenen diğer görseller.
Eşleştirme ve kullanım verileri:
Kullanıcıya sunulan profiller, seçimler, eşleşmeler, My Date durumları ve Platform içerisindeki etkileşimler.
Mesajlaşma ve iletişim verileri:
Kullanıcıların Platform üzerinden gerçekleştirdiği mesajlaşmalar, Çöpçatan mesajları ve bunlara ilişkin gönderen/alıcı, gönderim zamanı ve okunma durumuna ilişkin sınırlı teknik bilgiler.
Randevu bilgileri:
Platform üzerinden oluşturulan buluşmalara ilişkin tarih, saat ve yer bilgileri.
Geri bildirimler:
Eşleşme veya buluşma sonrasında Five Star’a iletilen değerlendirme ve açıklamalar.
Üyelik ve işlem bilgileri:
Üyelik durumu, satın alma ve abonelik durumu ile ödeme doğrulamasına ilişkin sınırlı işlem bilgileri.
Teknik ve güvenlik verileri:
Hesap ve kullanıcı kimlikleri, oturum bilgileri, güvenlik kayıtları, hata kayıtları ve Platformun çalışması sırasında oluşan teknik bilgiler.
Talep ve destek kayıtları:
Five Star ile gerçekleştirilen destek, gizlilik ve diğer iletişim yazışmaları.
3. INSTAGRAM KULLANICI ADININ KULLANIMI
Başvuru sırasında verilen Instagram kullanıcı adı, Five Star ekibi tarafından üyelik başvurusunun doğrulanması ve değerlendirilmesi amacıyla kullanılabilir.
Instagram kullanıcı adı diğer Five Star üyelerine gösterilmez, eşleşme profillerinde yer almaz ve diğer kullanıcılarla paylaşılmaz.
Bu bilgi yalnızca yetkili Five Star ekibinin erişebildiği yönetim alanlarında görüntülenir.
Instagram hesabının incelenmesi, Five Star tarafından kişinin kimliği, güvenilirliği veya davranışları hakkında garanti verildiği anlamına gelmez.
4. KİŞİSEL VERİLERİN İŞLENME AMAÇLARI
Kişisel veriler aşağıdaki amaçlarla işlenebilir:
• hesabın oluşturulması ve yönetilmesi,
• üyelik başvurusunun değerlendirilmesi,
• kullanıcı profilinin oluşturulması,
• Five Star’ın kürasyon ve eşleştirme hizmetinin sunulması,
• kullanıcılara belirli dönemlerde beş profil sunulması,
• eşleştirme kalitesinin geliştirilmesi,
• Platform içi mesajlaşmanın sağlanması,
• My Date özelliklerinin yürütülmesi,
• randevulaşma özelliklerinin sunulması,
• eşleşme ve buluşma geri bildirimlerinin değerlendirilmesi,
• kullanıcı güvenliğinin sağlanması,
• sahte, yanıltıcı veya kötüye kullanım amaçlı hesapların tespit edilmesi,
• destek ve kullanıcı taleplerinin yanıtlanması,
• üyelik ve abonelik durumunun doğrulanması,
• Platformun geliştirilmesi, güvenliği ve teknik olarak işletilmesi,
• yasal yükümlülüklerin yerine getirilmesi ve hakların korunması.
5. EŞLEŞTİRME VE KÜRASYON SÜRECİ
Five Star, sınırsız profil görüntülemeye dayalı klasik swipe modelinden farklı olarak kürasyonlu bir eşleştirme sistemi kullanır.
Kullanıcılara belirli dönemlerde beş profil sunulur.
Bu profillerin belirlenmesinde başvuru sırasında verilen bilgiler, kullanıcı tercihleri, Platform içerisindeki geçmiş etkileşimler, uygunluk durumları ve eşleştirme sürecinde kullanılan diğer bilgiler değerlendirilebilir.
Eşleştirme sürecinde manuel kürasyon, yazılım destekli değerlendirme veya bunların birlikte kullanılması söz konusu olabilir.
Five Star, belirli bir kullanıcıyla eşleşme, iletişim kurulması, buluşma veya ilişki kurulması garantisi vermez.
6. PLATFORM İÇİ ETKİLEŞİMLER
Five Star, kullanıcıların Platform içerisindeki seçim ve etkileşimlerinden elde edilen bilgileri eşleştirme hizmetini geliştirmek ve Platformun işleyişini yönetmek amacıyla değerlendirebilir.
Bu kapsamda oluşturulan bazı iç değerlendirme ve eşleştirme sinyalleri yalnızca Five Star’ın yetkili ekibi tarafından görülebilir ve diğer kullanıcılara gösterilmez.
7. MESAJLAŞMA VE GERİ BİLDİRİMLER
Platform içerisindeki mesajlaşmalar, hizmetin sağlanması ve kullanıcı güvenliğinin korunması amacıyla işlenebilir.
Eşleşme veya buluşma sonrasında Five Star’a iletilen geri bildirimler, gelecekteki eşleşmelerin iyileştirilmesi, hizmet kalitesinin geliştirilmesi ve gerektiğinde güvenlik veya moderasyon süreçlerinin yürütülmesi amacıyla kullanılabilir.
Bir kullanıcı tarafından Five Star’a verilen özel geri bildirimler, Platformda aksi açıkça belirtilmedikçe geri bildirimin konusu olan diğer kullanıcıya gösterilmez.
8. ÜYELİK VE ÖDEME BİLGİLERİ
Five Star üyelik hizmetleri ücretli olarak sunulabilir.
Uygulama içi üyelik ödemeleri, kullanıcının cihazına ve kullandığı platforma bağlı olarak Apple App Store veya Google Play üzerinden gerçekleştirilebilir.
Five Star, kullanıcıların kredi kartı veya banka kartı numaralarını doğrudan toplamaz veya saklamaz.
Ödeme işlemleri ilgili uygulama mağazasının ödeme altyapısı üzerinden yürütülür.
Five Star, üyeliğin etkinleştirilmesi, aboneliğin doğrulanması ve hizmetin sunulması amacıyla satın alma ve abonelik durumuna ilişkin sınırlı işlem bilgilerini işleyebilir.
Apple App Store veya Google Play tarafından doğrudan işlenen kişisel veriler, ilgili platformun kendi gizlilik politikaları kapsamında değerlendirilir.
9. KİŞİSEL VERİLERİN İŞLENMESİNİN HUKUKİ SEBEPLERİ
Kişisel veriler, ilgili işleme faaliyetine göre KVKK kapsamında;
• bir sözleşmenin kurulması veya ifasıyla doğrudan doğruya ilgili olması,
• Five Star’ın hukuki yükümlülüklerinin yerine getirilmesi için zorunlu olması,
• bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması,
• ilgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla Five Star’ın meşru menfaatleri için veri işlemenin zorunlu olması
hukuki sebeplerine dayanılarak işlenebilir.
Açık rıza gerektiren bir veri işleme faaliyeti söz konusu olduğunda ilgili açık rıza ayrıca alınır.
10. ÖZEL NİTELİKLİ KİŞİSEL VERİLER
Five Star kapsamında özel nitelikli kişisel verilerin işlenmesi söz konusu olması halinde bu veriler KVKK ve ilgili mevzuatta öngörülen şartlara uygun şekilde işlenir ve gerekli ek güvenlik tedbirleri uygulanır.
Özel nitelikli kişisel veriler, gerekli hukuki şartlar bulunmadıkça işlenmez.
11. KİŞİSEL VERİLERİN AKTARILMASI
Five Star’ın çalışması için barındırma, veritabanı, kimlik doğrulama, uygulama dağıtımı, ödeme, teknik altyapı, hata takibi veya benzeri hizmetler sunan üçüncü taraf hizmet sağlayıcılardan yararlanılabilir.
Kişisel veriler, yalnızca hizmetin yürütülmesi için gerekli olduğu ölçüde ve yürürlükteki mevzuata uygun şekilde yetkili hizmet sağlayıcılara, kanunen yetkili kamu kurumlarına veya diğer yetkili taraflara aktarılabilir.
Kişisel verilerin yurt dışına aktarılması söz konusu olduğunda KVKK’nın yurt dışına veri aktarımına ilişkin hükümleri uygulanır.
12. KİŞİSEL VERİLERİN TOPLANMA YÖNTEMİ
Kişisel veriler;
• mobil uygulamada doldurulan başvuru ve profil formları,
• Platforma yüklenen içerikler,
• Platform içerisindeki seçim ve etkileşimler,
• mesajlaşmalar,
• randevu ve geri bildirim özellikleri,
• Five Star ile gerçekleştirilen iletişim,
• üyelik ve abonelik işlemleri,
• Platformun çalışması sırasında otomatik olarak oluşan teknik kayıtlar
aracılığıyla elektronik ortamda toplanabilir.
13. KİŞİSEL VERİLERİN SAKLANMASI
Kişisel veriler, işlenme amaçlarının gerektirdiği süre boyunca ve ilgili mevzuat kapsamında zorunlu olan saklama süreleri boyunca muhafaza edilir.
Kişisel verilerin işlenmesini gerektiren sebeplerin ortadan kalkması halinde veriler, ilgili mevzuata uygun şekilde silinir, yok edilir veya anonim hâle getirilir.
Bir hesabın silinmesi, hukuken saklanması zorunlu olan tüm kayıtların aynı anda silineceği anlamına gelmeyebilir.
14. HESAP SİLME VE VERİ TALEPLERİ
Kullanıcılar, Platform içerisinde sunulan hesap silme özelliği üzerinden hesaplarının silinmesini talep edebilir.
Kişisel verilerine erişme, verilerinin düzeltilmesini isteme, silme veya diğer gizlilik talepleri için:
privacy@meetfivestar.app
adresinden Five Star’a ulaşılabilir.
Teknik destek ve uygulama kullanımıyla ilgili konular için:
support@meetfivestar.app
adresinden iletişime geçilebilir.
15. KVKK KAPSAMINDAKİ HAKLARIN
KVKK’nın 11. maddesi kapsamında kullanıcılar;
• kişisel verilerinin işlenip işlenmediğini öğrenme,
• kişisel verileri işlenmişse buna ilişkin bilgi talep etme,
• kişisel verilerin işlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,
• kişisel verilerin aktarıldığı üçüncü kişileri öğrenme,
• eksik veya yanlış işlenmiş kişisel verilerin düzeltilmesini isteme,
• şartları oluştuğunda kişisel verilerin silinmesini veya yok edilmesini isteme,
• düzeltme veya silme işlemlerinin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme,
• yalnızca otomatik sistemler aracılığıyla analiz edilen veriler sonucunda aleyhe bir sonucun ortaya çıkmasına itiraz etme,
• kişisel verilerin hukuka aykırı işlenmesi nedeniyle zarara uğranması halinde zararın giderilmesini talep etme
haklarına sahiptir.
16. VERİ GÜVENLİĞİ
Five Star, kişisel verilerin hukuka aykırı olarak işlenmesini ve kişisel verilere hukuka aykırı erişilmesini önlemek, kişisel verilerin güvenli şekilde muhafaza edilmesini sağlamak amacıyla uygun teknik ve idari tedbirler almaya çalışır.
Bununla birlikte hiçbir dijital sistemin tüm risklerden tamamen arındırılmış olduğu garanti edilemez.
17. AYDINLATMA METNİNİN GÜNCELLENMESİ
Five Star’ın hizmetlerinde, veri işleme faaliyetlerinde veya ilgili mevzuatta değişiklik olması halinde bu Aydınlatma Metni güncellenebilir.
Metnin güncel sürümüne Five Star uygulaması içerisinden ve/veya meetfivestar.app üzerinden erişilebilir.
18. İLETİŞİM
Five Star
Web:
meetfivestar.app
Kişisel veri ve gizlilik talepleri:
privacy@meetfivestar.app
Teknik destek:
support@meetfivestar.app
Genel iletişim:
hello@meetfivestar.app
Veri Sorumlusu:
[YASAL ŞİRKET / TÜZEL KİŞİ UNVANI]
Yasal adres:
[YASAL ADRES]`;
